import styled from 'styled-components'

export const CaptionChart = ({
  source,
  caption,
  link,
  colorMode,
}: {
  source?: string
  caption?: string
  link?: string
  colorMode: 'dark' | 'light'
}) => {
  return (
    <>
      {(caption || source) && (
        <Caption className='caption'>
          {caption}
          {link && source ? (
            <Source>
              <a target='_blank' rel='noreferrer' href={link}>
                {source}
              </a>
            </Source>
          ) : source ? (
            <Source>{source}</Source>
          ) : (
            <></>
          )}
        </Caption>
      )}
    </>
  )
}
// const Source = styled.div`
//   font-size: 12px;
//   color: var(--gray-3);
//   margin-bottom: 40px;
//   text-align: left;
// `

const Source = styled.div`
  margin-top: 0.5em;
  font-weight: 400;
  color: var(--gray-3);
  font-size: 1.2rem;
  line-height: 1.8rem;
`

const Caption = styled.figcaption`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  margin-bottom: 6rem;
  @media only screen and (max-width: 712px) {
    margin-bottom: 4rem;
  }
  .source {
    margin-top: 0.5em;
    font-weight: 400;
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
  a {
    color: var(--gray-3);
    text-decoration: none;
  }
`
